<template>
    <div>
        <v-container fluid pa-0>
            <v-card elevation="0">
                <v-container fluid grid-list-xl class="toolbar-container">
                    <v-layout row wrap :class="$bp.smallScreen ? 'mx-0' : null">
                        <v-toolbar color="grey lighten-3" elevation="1">
                            <bc-btn-back></bc-btn-back>
                            <v-toolbar-title class="ml-0">{{ $t($route.meta.title) }}</v-toolbar-title>
                            <v-spacer></v-spacer>
                            <bc-btn-add
                                @invoke-method="invokeMethod($event)"
                                dialog-model="shipping_carrier_dialog"
                                perm="companies.create"
                            ></bc-btn-add>
                            <bc-btn-refresh @invoke-method="dbGetShippingCarriers(true)"></bc-btn-refresh>
                            <bc-search-menu :params="axiosParams">
                                <v-list>
                                    <v-list-tile class="mb-3">
                                        <bc-search-input v-model="filter.search" :params="axiosParams"></bc-search-input>
                                    </v-list-tile>

                                    <v-list-tile>
                                        <v-list-tile-action>
                                            <v-switch
                                                v-model="filter.status"
                                                color="success"
                                                :label="$t('lang.active_only')"
                                                true-value="1"
                                                false-value="0"
                                            ></v-switch>
                                        </v-list-tile-action>
                                    </v-list-tile>
                                </v-list>
                            </bc-search-menu>
                            <bc-btn-mobile-nav @invoke-method="invokeMethod($event)" :mobile-list="mobile_list"></bc-btn-mobile-nav>
                        </v-toolbar>
                    </v-layout>
                </v-container>

                <v-card-text :class="$bp.smallScreen ? 'pa-0' : null">
                    <v-data-table :headers="headers" :items="shipping_carriers" :no-data-text="$t('lang.no_results_matching')" hide-actions>
                        <template slot="items" slot-scope="props">
                            <tr class="clickable" @mouseup.left="openShippingCarrierForm(props.item)">
                                <td><img :src="props.item.logo" style="max-width: 50px; max-height: 50px" /></td>
                                <td>{{ props.item.company }}</td>
                            </tr>
                        </template>
                    </v-data-table>
                    <bc-pagination :page="page" :params="axiosParams" name="shipping_carriers"></bc-pagination>
                </v-card-text>
            </v-card>

            <bc-dialog :value="shipping_carrier_dialog">
                <v-card>
                    <v-form ref="form_shipping_carrier">
                        <v-card-title>
                            <span class="headline">{{ shipping_carrier.company_id ? $t("lang.edit_shipping_carrier") : $t("lang.add_shipping_carrier") }}</span>
                            <v-spacer></v-spacer>
                            <bc-btn-dialog-close
                                @invoke-method="invokeMethod($event)"
                                action="closeShippingCarrierDialog"
                                :dialog-status="shipping_carrier_dialog"
                            ></bc-btn-dialog-close>
                        </v-card-title>
                        <v-card-text>
                            <v-form ref="form_shipping_carrier" @submit.prevent>
                                <v-container grid-list-form>
                                    <v-layout row wrap>
                                        <v-flex xs12>
                                            <v-text-field
                                                v-focus="shipping_carrier_dialog"
                                                v-model="shipping_carrier.company"
                                                :label="`${$t('lang.company')} *`"
                                                :counter="showCounter(shipping_carrier.company, 'shipping_carrier.company')"
                                                :rules="ifValid('shipping_carrier.company')"
                                            ></v-text-field>
                                        </v-flex>
                                    </v-layout>
                                </v-container>
                            </v-form>
                        </v-card-text>
                        <v-card-actions>
                            <v-btn v-if="shipping_carrier.company_id" color="error" @mouseup.left="$refs.delete_shipping_carriers.openDialog()">{{
                                $t("lang.delete")
                            }}</v-btn>
                            <v-spacer></v-spacer>
                            <v-btn flat @mouseup.left="closeShippingCarrierDialog()">{{ $t("lang.cancel") }}</v-btn>
                            <v-btn color="success" @click="saveShippingCarriers">{{ $t("lang.save") }}</v-btn>
                        </v-card-actions>
                    </v-form>
                </v-card>
            </bc-dialog>
            <delete-confirmation-dialog
                ref="delete_shipping_carriers"
                :heading="$t('lang.delete_shipping_carrier')"
                :message="$t('lang.confirm_delete_message')"
                @onConfirm="deleteShippingCarriers(shipping_carrier.company_id)"
            ></delete-confirmation-dialog>
        </v-container>
    </div>
</template>

<script>
import { mapGetters, mapState, mapActions, mapMutations } from "vuex";
import { store } from "Store/store";

export default {
    data() {
        return {
            mobile_list: [
                { title: this.$t("lang.add_new"), action: "openShippingCarrierForm" },
                { title: this.$t("lang.refresh"), action: "dbGetShippingCarriers", params: [true] },
            ],
            headers: [{ text: "", sortable: false, align: "center", width: "60" }, { text: this.$t("lang.provider"), sortable: false }],
            shipping_carrier: {},
            filter: {
                search: "",
                company_id: "",
                status: "1",
            },
            shipping_carrier_dialog: false,
            dbGetShippingCarriers: _.debounce(this.getShippingCarriers, 1500, { maxWait: 1500, leading: true, trailing: false }),
        };
    },
    beforeRouteEnter(to, from, next) {
        let parsedQuery = JSON.parse(JSON.stringify(to.query));
        store
            .dispatch("fetchShippingCarriers", {
                body: parsedQuery,
            })
            .then((data) => {
                if (typeof data !== "undefined" && data.shipping_carriers) {
                    next((vm) => {
                        vm.setQuery(parsedQuery, vm.filter, vm.default_filter);
                        vm.finishLoader();
                    });
                } else {
                    next({ name: "dashboard", replace: true });
                }
            });
    },
    beforeRouteUpdate(to, from, next) {
        let parsedQuery = JSON.parse(JSON.stringify(to.query));
        this.fetchShippingCarriers({
            body: parsedQuery,
        }).then((data) => {
            if (typeof data !== "undefined" && data.shipping_carriers) {
                this.setQuery(parsedQuery, this.filter, this.default_filter);
                this.finishLoader();
                next();
            } else {
                next({ name: "dashboard", replace: true });
            }
        });
    },
    computed: {
        ...mapState({
            default_filter: (state) => state.shipping_carriers.shipping_carriers_filter,
            page: (state) => state.shipping_carriers.page,
            rules_shipping_carriers: (state) => state.shipping_carriers.rules_shipping_carriers,
            shipping_carrier_status_options: (state) => state.settings.shipping_carrier_status_options,
            shipping_carriers: (state) => state.shipping_carriers.shipping_carriers,
        }),
        axiosParams() {
            return this.prepareParams(this.filter, this.default_filter);
        },
    },
    methods: {
        ...mapActions(["fetchShippingCarriers", "saveShippingCarrier", "deleteShippingCarrier"]),
        ...mapMutations(["validationOn", "validationOff", "toggleGlobalSnackbar", "toggleModalLoader"]),
        openShippingCarrierForm(item = null) {
            if (item != null) {
                this.$router.push({ name: "shipping_carrier", params: { id: item.company_id } });
            } else {
                this.$router.push({ name: "shipping_carrier" });
            }
        },
        saveShippingCarriers() {
            this.validationOn();
            this.$nextTick(() => {
                if (this.validateForm("form_shipping_carrier")) {
                    let body = this.prepForm(this.shipping_carrier, this.rules_shipping_carriers);

                    this.saveShippingCarrier({
                        body: body,
                    }).then((data) => {
                        if (data && data.code == "200") {
                            this.$router.push({ name: "shipping_carrier", params: { id: data.shipping_carrier.company_id } });
                        } else {
                            //this.toggleModalLoader(false);
                        }
                    });
                }
            });
        },
        deleteShippingCarriers(id = null) {
            this.deleteShippingCarrier({
                id: id,
            }).then((data) => {
                if (data && data.code == "200") {
                    this.getShippingCarriers();
                    this.closeShippingCarrierDialog();
                } else {
                    this.toggleModalLoader(false);
                }
            });
        },

        closeShippingCarrierDialog() {
            this.shipping_carrier_dialog = false;
            this.$refs.delete_shipping_carriers.close();
            this.validationOff();
            this.toggleModalLoader(false);
        },
        getShippingCarriers(pg_refresh = false) {
            this.startLoader();

            this.fetchShippingCarriers({
                body: JSON.parse(JSON.stringify(this.$route.query)),
            })
                .then((data) => {
                    if (typeof data === "undefined") this.$router.push({ name: "dashboard" });
                })
                .finally(() => {
                    this.shipping_carrier_dialog = false;
                    this.toggleModalLoader(false);
                    this.validationOff();
                    this.finishLoader(pg_refresh);
                });
        },
    },
};
</script>
